import { styled } from "@mui/material";
import { BaseButton } from "components/buttons/BaseButton";
import { useEffect, useRef, useState } from "react";
import { UseFormGetValues, UseFormSetValue, FieldPath } from "react-hook-form";
import { useSelector } from "react-redux";
import { useKeyPress } from "../../../../../hooks/useKeyPress";
import { IAppState } from "../../../../../store/app-state";
import SelectTags from "components/upload/SelectTags";
import UploadSearch from "../../../../upload/UploadSearch";
import { ISignUpFieldValues } from "../AuthSignUp";

interface IProps {
  setValue: UseFormSetValue<ISignUpFieldValues>;
  getValues: UseFormGetValues<ISignUpFieldValues>;
}

const SignUpTopicsStep = (props: IProps) => {
  const { setValue, getValues } = props;

  const tags = useSelector((state: IAppState) => state.tags.tags);

  const [selectedTags, setSelectedTags] = useState(getValues().tags ? getValues().tags : []);
  const [filteredTags, setFilteredTags] = useState<any>(tags);

  const enterPressed = useKeyPress("Enter");

  const submitRef = useRef<any>(null);

  const sortSelected = (tags: any) => {
    const newPaginated = [...tags];

    newPaginated.sort((el: any) => {
      let isExist = false;

      selectedTags.forEach((tag: any) => {
        if (tag === el.name) {
          isExist = true;
        }
      });

      return isExist ? -1 : 0;
    });

    setFilteredTags(newPaginated);
  };

  const search = (value: string) => {
    if (value) {
      const newTags = tags.filter((el: any) => el.name.toLowerCase().includes(value.toLowerCase()));
      setFilteredTags(newTags);
    } else {
      sortSelected(tags);
    }
  };

  useEffect(() => {
    setValue<FieldPath<ISignUpFieldValues>>("tags", selectedTags);
    // eslint-disable-next-line
  }, [selectedTags])

  useEffect(() => {
    if (enterPressed && submitRef && submitRef.current) {
      submitRef.current.click();
    }
  }, [enterPressed]);

  return (
    <Container>
      <Label>Select your favourite tags:</Label>
      <UploadSearch onSearch={search}/>
      <TagsWrapper>
        <SelectTags tags={filteredTags} setTags={setSelectedTags} mainSelectedTags={selectedTags} invertColor={true}/>
      </TagsWrapper>
      <StyledBaseButton>
        <BaseButton type="submit" ref={submitRef}>Register</BaseButton>
      </StyledBaseButton>
    </Container>
  );
};

export default SignUpTopicsStep;

const Container = styled("div")({
  marginTop: "2rem",
  display: "flex",
  flexDirection: "column",
  gap: "1rem",
  height: "100%"
});

const Label = styled("label")({
  fontWeight: "500",
  fontSize: "14px"
});

const TagsWrapper = styled("div")({
  maxHeight: "340px",
  overflowY: "auto",
  paddingBottom: "100px",
  ".phone &, .tablet &": {
    maxHeight: "320px"
  },
  "&::-webkit-scrollbar": {
    display: "none"
  },
  "& > div": {
    marginTop: 0,
  }
});

const StyledBaseButton = styled("div")({
  position: "absolute",
  bottom: "0",
  left: "0",
  width: "100%",
  padding: "16px 16px 32px",
  background: "rgba(255, 255, 255, 0.9)",
  borderRadius: "24px"
});
